/***
 *
 *   CHECKLIST
 *   Items with X or ✓
 *
 *   PROPS
 *   items: array of objects containing keys: name (string) and checked (bool)
 *
 **********/

import type { ElementType } from 'react';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import { emphasize, styled } from '@mui/material/styles';
import Chip from '@mui/material/Chip';

const StyledBreadcrumb = styled(Chip)<{ component?: ElementType }>(({ theme }) => {
  const backgroundColor = theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[800];
  return {
    backgroundColor,
    height: theme.spacing(3),
    color: theme.palette.text.primary,
    fontWeight: theme.typography.fontWeightRegular,
    cursor: 'pointer',
    '& .MuiChip-label': {
      cursor: 'pointer',
    },
    '&:hover, &:focus': {
      backgroundColor: emphasize(backgroundColor, 0.06),
    },
    '&:active': {
      boxShadow: theme.shadows[1],
      backgroundColor: emphasize(backgroundColor, 0.12),
    },
  };
});

interface CheckListItem {
  name: string;
  checked?: boolean;
  onClick?: () => void;
}

interface CheckListProps {
  items?: CheckListItem[];
  color?: string;
  className?: string;
  hideCross?: boolean;
  interactive?: boolean;
}

export function CheckList(props: CheckListProps) {
  if (!props.items) return <div>No items in list</div>;

  return (
    <>
      <Breadcrumbs>
        {props.items.map((item, index) => {
          return (
            <StyledBreadcrumb
              component="a"
              label={item.name}
              onClick={item.onClick}
              clickable={Boolean(item.onClick)}
              key={index}
              className={item.checked ? 'active-breadcrumb' : ''}
            />
          );
        })}
      </Breadcrumbs>
      <br />
      <br />
    </>
  );
}
